import { FieldCommonProps } from 'components/business/SurveyForm/Fields/type'
import { useEffect } from 'preact/hooks'

export default function usePropValueChange({ value }: FieldCommonProps, callback: () => void) {
  useEffect(() => {
    if (value === undefined) {
      callback()
    }
  }, [value])
}
